const doc = [({"da":({"js":({"admin":({"photos":({"table":({"photo":"Foto", "the_photo_type_on_the_photo_was_saved":"Fototypen på foto blev gemt."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;